<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="LOCALIDADES" key="1">
        <a-row>
          <g-master name="Localidades"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    ref="master"
                    modalWidth="80%"
          >
            <span slot="estadoRenderer" slot-scope="{text}">
              <div v-if="text ==='INA'">
                <a-tag color="red">INACTIVO</a-tag>
              </div>
              <div v-if="text ==='ACT'">
                <a-tag color="blue">ACTIVO</a-tag>
              </div>
            </span>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Descripción')">
                    <a-input style="width: 100%;"
                             v-decorator="['office_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Dirección')">
                    <a-input style="width: 100%;"
                             v-decorator="['off_address', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Teléfono')">
                    <a-input style="width: 100%;"
                             v-decorator="['off_phone', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Celular')">
                    <a-input style="width: 100%;"
                             v-decorator="['off_cell_phone', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Correo')">
                    <a-input style="width: 100%;"
                             v-decorator="['off_mail', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="company"
                              :label="$t('Compañía')"
                              :formItemConfig="fiOptions"
                              :decorator="['company', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :label="$t('País')"
                              :formItemConfig="fiOptions"
                              :params="id_h_country"
                              :decorator="['id_h_country', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-lookup endpoint="hierarchy_lookup"
                              :label="$t('Ciudad')"
                              :formItemConfig="fiOptions"
                              :params="id_h_city"
                              :decorator="['id_h_city', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                  >
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown v-bind="fiOptions"
                              endpoint="hierarchy_lookup"
                              :label="$t('Estado')"
                              :formItemConfig="fiOptions"
                              :decorator="['office_status', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                              :params="estado">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('ID Emp. lvl1')">
                    <a-input style="width: 100%;"
                             v-decorator="['id_emp_level1', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('ID Emp. lvl2')">
                    <a-input style="width: 100%;"
                             v-decorator="['id_emp_level2', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('ID Emp. lvl3')">
                    <a-input style="width: 100%;"
                             v-decorator="['id_emp_level3', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-row>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tpay: {
          h_lookup_type: 'TIPO PAGO',
          use_code: true
        },
        estado: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        id_h_country: {
          h_lookup_type: 'PAISES_HV'
        },
        id_h_city: {
          h_lookup_type: 'CIUDADES_HV'
        },
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          endpoint: 'offices',
          tableSetup: {
            customSlots: ['estadoRenderer'],
            tableConfig: {
              rowKey: 'office_id'
            },
            columns: [
              {title: '#', dataIndex: 'office_id', sorter: true},
              {title: 'Descripción', dataIndex: 'office_name', sorter: true},
              {title: 'Dirección', dataIndex: 'off_address', sorter: true},
              {title: 'Teléfono', dataIndex: 'off_phone', sorter: true},
              {title: 'Celular', dataIndex: 'off_cell_phone', sorter: true},
              {title: 'Correo', dataIndex: 'off_mail', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'office_status',
                sorter: true,
                scopedSlots: {
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'ID Compañía', dataIndex: 'company', sorter: true},
              {title: 'Compañía', dataIndex: 'company_desc', sorter: true},
              {title: 'ID País', dataIndex: 'id_h_country', sorter: true},
              {title: 'País', dataIndex: 'country_desc', sorter: true},
              {title: 'ID Ciudad', dataIndex: 'id_h_city', sorter: true},
              {title: 'Ciudad', dataIndex: 'city_desc', sorter: true},
              {title: 'ID Emp. lvl1', dataIndex: 'id_emp_level1', sorter: true},
              {title: 'ID Emp. lvl2', dataIndex: 'id_emp_level2', sorter: true},
              {title: 'ID Emp. lvl3', dataIndex: 'id_emp_level3', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'office_name'},
            {name: 'off_address'},
            {name: 'off_phone'},
            {name: 'off_cell_phone'},
            {name: 'off_mail'},
            {name: 'office_status'},
            {name: 'company'},
            {name: 'id_h_country'},
            {name: 'id_h_city'},
            {name: 'id_emp_level1'},
            {name: 'id_emp_level2'},
            {name: 'id_emp_level3'}
          ]
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Localidades/Localidades.vue